import { Flex, Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";

const OnboardingStep1 = ({ formData, handleChange }) => {

  const handleLeiChange = (e) => {
    const { value } = e.target;
    if (/^[A-Z0-9]{0,20}$/.test(value)) {
      handleChange(e);
    }
  };

  const handleRcsChange = (e) => {
    const { value } = e.target;
    if (/^\d{0,6}$/.test(value)) {
      handleChange(e);
    }
  };


  return (
    
<>   
    <Flex direction="column" gap={8}>
      <h6>Fund identification</h6>
      <Flex direction="column">
        
        <Fieldset
          label="Fund Name"
          description="Provide the official name of the fund as registered."
          input={
            <Input
              name="fundName"
              placeholder="Enter fund name"
              value={formData.fundName}
              onChange={handleChange}
            />
          }
        />

        <Fieldset
          label="RCS Number"
          description="Enter the RCS (Company Register) number for the fund. Must be exactly 6 digits."
          input={
            <InputGroup>
              <InputLeftAddon children="B" />
              <Input
                name="rcsNumber"
                placeholder="Enter RCS number"
                value={formData.rcsNumber}
                onChange={handleRcsChange}
              />
            </InputGroup>
          }
        />

        <Fieldset
          label="LEI Code"
          description="Enter the Legal Entity Identifier (LEI) code. Must be 20 uppercase letters or digits."
          input={
            <Input
              name="leiCode"
              placeholder="Enter LEI code"
              value={formData.leiCode}
              onChange={handleLeiChange}
            />
          }
        />

        <Fieldset
          label="CSSF ID"
          description="Provide the CSSF identification number associated with the fund."
          input={
            <Input
              name="cssfId"
              placeholder="Enter CSSF ID"
              value={formData.cssfId}
              onChange={handleChange}
            />
          }
        />
      </Flex>
      </Flex>

      
</>
  );
};

export default OnboardingStep1;
